import { css } from '@emotion/react';
import type * as React from 'react';

const containerStyle = css`
	display: flex;
	flex-direction: column;
	gap: 0.75rem;
	height: 100%;
	min-height: 0;
`;

type Props = {
	readonly children: React.ReactNode;
};

/** The box of a dossier list's content. */
const SubjectListContainer: React.FC<Props> = ({ children }) => {
	return <div css={containerStyle}>{children}</div>;
};

export default SubjectListContainer;
